import React from 'react';
import getUserFromMeetingInvite from '../../../../../misc/getUserFromMeetingInvite';
import ParticipantListItem from '../../../ParticipantListItem';

function MeetingParticipant(props) {
    const { invite, i18n } = props,
        { user } = invite;

    if (!user?.first_name) return null;

    return <ParticipantListItem participant={getUserFromMeetingInvite(invite, i18n)} showUserDetails tagName="div" />;
}

export default MeetingParticipant;
